import { LoadingOverlay } from '@/components/loading-overlay/loading-overlay';
import { IDashboardSummaryTopOrder } from '@/modules/dashboard/summary/model/summary';

const DashboardSummaryTopOrder: React.FC<{
  topOrderData: IDashboardSummaryTopOrder,
  isLoading: boolean,
}> = (props) => (
  <div className="bg-white p-5 rounded-xl mb-5">
    <LoadingOverlay isLoading={props?.isLoading}>
      <span className="text-lg font-bold">Table</span>

      <div className="grid grid-cols-3 gap-4 mt-4 text-center">
        <div className="shadow-md rounded-lg border border-gray-200">
          <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2 border border-b">Top Order Pengirim</div>
          <div className="w-full max-h-64 overflow-y-auto">
            <table className="w-full text-sm text-left rounded-b-lg overflow-hidden">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2 border-0">Nama Pengirim</th>
                  <th className="px-4 py-2 border-0 text-right">Order</th>
                </tr>
              </thead>
              <tbody>
                {props?.topOrderData?.top_order_shipper?.map((value, index) => (
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
                  >
                    <td className="px-4 py-2 border-0">{value.shipper_name}</td>
                    <td className="px-4 py-2 border-0 text-right">{value.total_order}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="shadow-md rounded-lg border border-gray-200">
          <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2 border border-b">Top Order Asal</div>
          <div className="max-h-64 overflow-y-auto">
            <table className="w-full text-sm text-left rounded-b-lg overflow-hidden">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2 border-0">Kode</th>
                  <th className="px-4 py-2 border-0">Nama Origin</th>
                  <th className="px-4 py-2 border-0 text-right">Order</th>
                </tr>
              </thead>
              <tbody>
                {props?.topOrderData?.top_order_origin?.map((value, index) => (
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
                  >
                    <td className="px-4 py-2 border-0">{value.origin_city_id}</td>
                    <td className="px-4 py-2 border-0">{value.origin_city_name}</td>
                    <td className="px-4 py-2 border-0 text-right">{value.total_order}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="shadow-md rounded-lg border border-gray-200">
          <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2 border border-b">Top Order Tujuan</div>
          <div className="w-full max-h-64 overflow-y-auto">
            <table className="w-full text-sm text-left rounded-b-lg overflow-hidden">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2 border-0">Kode</th>
                  <th className="px-4 py-2 border-0">Nama Destination</th>
                  <th className="px-4 py-2 border-0 text-right">Order</th>
                </tr>
              </thead>
              <tbody>
                {props?.topOrderData?.top_order_destination?.map((value, index) => (
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
                  >
                    <td className="px-4 py-2 border-0">{value.destination_city_id}</td>
                    <td className="px-4 py-2 border-0">{value.destination_city_name}</td>
                    <td className="px-4 py-2 border-0 text-right">{value.total_order}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 mt-4 text-center">
        <div className="shadow-md rounded-lg border border-gray-200">
          <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2 border border-b">Top Order Per Rute</div>
          <div className="w-full max-h-64 overflow-y-auto">
            <table className="w-full text-sm text-left rounded-b-lg overflow-hidden">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2 border-0">Kota Origin</th>
                  <th className="px-4 py-2 border-0">Kecamatan Origin</th>
                  <th className="px-4 py-2 border-0">Kota Tujuan</th>
                  <th className="px-4 py-2 border-0">Kecamatan Tujuan</th>
                  <th className="px-4 py-2 border-0">Total Resi</th>
                </tr>
              </thead>
              <tbody>
                {props?.topOrderData?.top_order_route?.map((value, index) => (
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
                  >
                    <td className="px-4 py-2 border-0">{value.origin_city_name}</td>
                    <td className="px-4 py-2 border-0">{value.origin_subdistrict_name}</td>
                    <td className="px-4 py-2 border-0">{value.destination_city_name}</td>
                    <td className="px-4 py-2 border-0">{value.destination_subdistrict_name}</td>
                    <td className="px-4 py-2 border-0 text-right">{value.total_order}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  </div>
);

export default DashboardSummaryTopOrder;
